
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


export const isEmpty = (obj: any) => {
    return !obj ||
        (typeof obj === "string" && obj.length === 0) ||
        (typeof obj === "object" &&
            (Object.keys(obj).length === 0 || obj.length === 0));
}

export const isNotEmpty = (obj: any) => !isEmpty(obj);

export const formatDateTime = (utcDate: string) => {
    let dateObj;
    if (typeof utcDate !== "object") {
        let appendUTC = utcDate + " UTC";
        dateObj = new Date(appendUTC);
    }
    else {
        dateObj = utcDate;
    }
    let hours = dateObj.getHours();
    let minutes: any = dateObj.getMinutes();
    let day = days[dateObj.getDay()];
    let month = months[dateObj.getMonth()].substr(0, 3);
    let date: any = dateObj.getDate();
    let year: any = dateObj.getFullYear();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    date = date < 10 ? '0' + date : date;
    return hours + ":" + minutes + " " + ampm + " " + day + ", " + month + " " + date + ", " + year;
}

export const TRANSCRIPT_PARAMS: any = {
    "claimNumber": '[A-Z]{2}-[0]{7}-\\d{6}',
    "phoneNumber": '[0-9]{10}',
    "contactId": '[a-z]{2}:\\d',
}

export const formatPhoneNumber = (phoneNumber: string) => {
    return "+1" + phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3, 6) + "-" + phoneNumber.slice(6)
}

export const checkAllParamsRequestedForTranscript = (params: any) => {
    return isNotEmpty(params) && Object.keys(params)
        .every((param: string) => {
            return Object.keys(TRANSCRIPT_PARAMS).includes(param)
                && new RegExp(TRANSCRIPT_PARAMS[param], 'i').test(params[param])
        });
}

export const formatNewLinesInHtml = (str: any) => {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
}